import React from 'react';
import HeadingBox from './homecomponent/headingBox';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SlickSlider from './homecomponent/slickSlider';
import BlogContent from './homecomponent/blogFolder/blogContent';



const Blogs = () => {

  const tophead = "BLOGS";
  const subhead = "Discovering Innovation in Every Build";
  const blogPara = "From groundbreaking ideas to cost-saving hacks, discover the blueprint for construction excellence."
  return (
    <>
      <div id="blog" className="blogWrapper">

        <img
          className="blueprintrightblog"
          src="../../../images/home/benefit-right-blueprint.png"
          alt=""
        />

        <img className="leftGridblog" src="/images/home/leftGrid.png" alt="..." />

        <img
          className="blueprintbottomtblog"
          src="../../../images/home/benefit-right-blueprint.png"
          alt=""
        />
        <HeadingBox topheading={tophead} subheading={subhead} blogPargraph={blogPara} />



        <p style={{ maxWidth: "740px", marginBottom: "100px" }} className='para-text text-black mt-4'>From groundbreaking ideas to cost-saving hacks, discover the blueprint for  <br /> construction excellence. </p>

        <SlickSlider />
        <br />
        {/* <img className='blogArrows' src="/images/home/blogArrows.png" alt="..." /> */}

      </div>

    </>
  )
}

export default Blogs;